import { RetryableDonationFormInvariantError } from "../errors"
import { createDonation } from "../queries"
import {
  CreateDonationPayload,
  CreateDonationPayloadDesignationResource,
  Designation,
  State,
  StripeToken,
} from "../types"

// TODO: write tests

export abstract class FormSubmission {
  protected state: State
  protected stripeToken: StripeToken

  constructor({
    state,
    stripeToken,
  }: {
    state: State
    stripeToken: StripeToken
  }) {
    this.state = state
    this.stripeToken = stripeToken
    this.buildPayload()
  }

  static create({
    state,
    stripeToken,
  }: {
    state: State
    stripeToken: StripeToken
  }): FormSubmission {
    if (state.frequency.type === "once") {
      return new OneTimeFormSubmission({ state, stripeToken })
    } else {
      return new RecurringFormSubmission({ state, stripeToken })
    }
  }

  protected buildPayload(): void {}

  abstract submit(): Promise<void>
}

class OneTimeFormSubmission extends FormSubmission {
  private payload?: CreateDonationPayload

  async submit(): Promise<void> {
    if (!this.payload) {
      throw new RetryableDonationFormInvariantError()
    } else {
      createDonation({ payload: this.payload })
    }
  }

  protected buildPayload() {
    this.payload = {
      data: {
        attributes: {
          stripe_token: this.stripeToken,
        },
      },
      included: this.state.designations.map(this.designationToResource),
    }
  }

  private designationToResource(
    designation: Designation,
  ): CreateDonationPayloadDesignationResource {
    return {
      type: "Designation",
      attributes: { amount: designation.amount },
      relationships: {
        fund: {
          data: {
            type: "Fund",
            id: designation.fundId,
          },
        },
      },
    }
  }
}

class RecurringFormSubmission extends FormSubmission {
  submit(): Promise<void> {
    alert("Submitting recurring donation is not implemented yet")
    return Promise.resolve()
  }
}
